import { useState } from 'react';

const useDataImportDialog = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const open = () => {
    setIsOpen(true);
  };

  return { isOpen, open, handleClose };
};

export default useDataImportDialog;
